import React from "react";
import type { FC } from "react";

import { Link } from "../../../../Link";
import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";

import type { OmitOfUnion } from "../../../../../types/react";
import type { LinkProps } from "../../../../Link";

const CONTENT_LINK_TEST_ID = createTestIdForContentElement("link");

type AbsentedProps = "size" | "data-tsid";

type ContentLinkProps = OmitOfUnion<LinkProps, AbsentedProps>;

export const ContentLink: FC<ContentLinkProps> = ({ children, ...props }) => {
    return (
        <Link {...(props as LinkProps)} data-tsid={CONTENT_LINK_TEST_ID}>
            {children}
        </Link>
    );
};

ContentLink.displayName = createDisplayNameForContentElement("Link");

export default ContentLink;
